import React, { useEffect, useState } from 'react'
import {
  Button, Card, Col, Drawer, Form, Input, notification,
  Row, Select, Popconfirm, Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import {
  chooseEmailModalFxn, currencyList, formItemLayout
} from '../../../../components/_utils/appUtils'
// import { ApproveAbstract } from '../actions' // Ensure this is imported

const { Option } = Select

const ApprovalAbstractDrawer = props => {
  let {
    children,
    form: { getFieldDecorator, setFieldsValue },
    callback = null,
    visible,
    onClose,
    edit,
    abstract
  } = props

  const dispatch = useDispatch()
  const authorData1 = { authors: [], noOfAuthors: null }
  const [authorData, setAuthorData] = useState(authorData1)

  let _updateState = data => {
    setAuthorData(preState => ({ ...preState, ...data }))
  }

  const loopVal = noOfAuthors => {
    let count = parseInt(noOfAuthors) || 0
    let authors = Array.from({ length: count }, () => ({
      name: '', email: '', orchId: ''
    }))
    setAuthorData({ authors, noOfAuthors: count })
  }

  const deleteAuthors = index => {
    let cloneAuthor = _.clone(authorData.authors)
    cloneAuthor.splice(index, 1)
    setAuthorData({ authors: cloneAuthor, noOfAuthors: cloneAuthor.length })
  }

  const addNewAuthor = () => {
    let authors = _.clone(authorData.authors)
    authors.push({ name: '', email: '', orchId: '' })
    setAuthorData({ authors, noOfAuthors: authors.length })
  }

  const authorsUpdate = (data, index) => {
    let cloneAuth = _.clone(authorData.authors)
    if (cloneAuth[index]) {
      cloneAuth[index] = { ...cloneAuth[index], ...data }
      setAuthorData({ ...authorData, authors: cloneAuth })
    }
  }

  let setFormData = () => {
    if (edit) {
      setAuthorData({
        noOfAuthors: abstract.noOfAuthors,
        authors: abstract.doiAuthors || []
      })

      props.form.setFieldsValue({
        manuScriptTitle: abstract.manuScriptTitle,
        approvalAmount: abstract.approvalAmount,
        approvalInvoiceAddress: abstract.approvalInvoiceAddress, // Matches key in inputSchema
        invoiceDate: abstract.invoiceDate ? moment(abstract.invoiceDate) : moment(),
        currencyTypeOfApprovalAmount: abstract.currency, // Matches key in inputSchema
        approvedAbstractDate: abstract.approvedAbstractDate ? moment(abstract.approvedAbstractDate) : moment(),
        approvalSpecialNote: abstract.approvalSpecialNote
      })
    } else {
      props.form.setFieldsValue({
        manuScriptTitle: abstract.titleOfAbstract,
        invoiceDate: moment(),
        approvedAbstractDate: moment()
      })
    }
  }

  useEffect(() => {
    if (visible) {
      setTimeout(setFormData, 500)
    }
  }, [visible])

  const inputSchema = {
    fields: [
      { label: 'Abstract Title', key: 'manuScriptTitle', type: 'editor', required: true, span: 24 },
      { label: 'Approved Date', key: 'approvedAbstractDate', required: true, type: 'date' },
      { label: 'Invoice Date', key: 'invoiceDate', required: true, type: 'date' },
      // { label: 'Currency', key: 'currencyTypeOfApprovalAmount', required: true, type: 'select', options: currencyList },
      {
        label: 'Currency',
        key: 'currencyTypeOfApprovalAmount',
        required: true,
        type: 'select',
        options: currencyList,
        onChange: (value) => {
          setFieldsValue({ currencyTypeOfApprovalAmount: value });
        }
      },
      { label: 'Approval Amount', key: 'approvalAmount', required: true, type: 'number' },
      {
        label: 'Address',
        key: 'approvalInvoiceAddress',
        type: 'textArea',
        required: true,
        span: 16
      },
      { label: 'Special Note', key: 'approvalSpecialNote', span: 24, type: 'textArea' }
    ]
  }

  const handleSubmit = e => {
    e.preventDefault()
    props.form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        chooseEmailModalFxn({
          title: 'Approve Abstract',
          callback: async email => {
            valData.fromEmail = email
            valData.abstractId = abstract._id
            valData.template = 'approvedAbstract'
            if (!edit) {
              valData.abstractStatus = 'Approved Abstract'
              valData.approvedDate = new Date()
            }
            valData.doiAuthors = authorData.authors
            valData.noOfAuthors = authorData.noOfAuthors

            // let { success } = await dispatch(ApproveAbstract(valData))
            // if (success) {
            //   if (callback) callback()
            //   onClose()
            //   dispatch({ type: 'START_LOAD_ABSTRACT' })
            // }
          }
        })
      }
    })
  }

  return (
    <Drawer
      title={`Approve Abstract | ID: ${abstract.abstractNo || ''}`}
      width={'70%'}
      visible={visible}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={item.span || 8} key={key}>
                <GetEachFormFields getFieldDecorator={getFieldDecorator} item={item} formItemLayout={formItemLayout} />
              </Col>
            ))}
            <Col span={24}>
              <Card title='Authors' extra={
                <Button size='small' onClick={addNewAuthor} className='ant-btn ant-btn-primary'>Add Author</Button>
              }>
                <Form.Item label='Enter Number of Authors'>
                  <Input style={{ width: '34%' }} value={authorData.noOfAuthors} type={'number'} onChange={e => loopVal(e.target.value)} />
                </Form.Item>
                {authorData.authors.map((item, key) => (
                  <Row key={key} gutter={16}>
                    <Col span={8}>
                      <Form.Item label='Name'><Input value={item.name} onChange={e => authorsUpdate({ name: e.target.value }, key)} /></Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label='Email'><Input type={'email'} value={item.email} onChange={e => authorsUpdate({ email: e.target.value }, key)} /></Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label='Orch Id'>
                        <div className={'rowFlex'}>
                          <Input value={item.orchId} onChange={e => authorsUpdate({ orchId: e.target.value }, key)} />
                          <Button shape='circle' icon={'delete'} onClick={() => deleteAuthors(key)} />
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                ))}
              </Card>
            </Col>
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='primary' htmlType='submit'>Submit</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

export default Form.create()(ApprovalAbstractDrawer)
